module.exports = __webpack_public_path__ + "static/media/select-plan.418ecd86.png";